import { Box, Button, IconButton, Modal } from '@mui/material';
import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreateBroker from './Create';
import { ReactTable } from '@components';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { MRT_ToggleGlobalFilterButton } from 'material-react-table';
import { apiDeleteBroker, deleteBroker } from '@store';
import { showToast } from '@utils';

const Brokers = () => {
    const dispatch = useDispatch();
    const { brokers, isGetBrokerLoading } = useSelector(
        (state) => state.broker
    );

    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
        setOpenModal(true);
    };
    const handleCloseModal = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpenModal(false);
        }
    };

    const handleDelete = useCallback(
        async (broker) => {
            if (
                window.confirm('Are you sure you want to delete this broker?')
            ) {
                const resp = await dispatch(apiDeleteBroker(broker));
                if (resp?.meta?.requestStatus === 'fulfilled') {
                    dispatch(deleteBroker(broker));
                    showToast('info', 'Broker deleted successfully');
                } else if (resp?.meta?.requestStatus === 'rejected') {
                    showToast('error', resp.payload);
                }
            }
        },
        [dispatch]
    );

    const columns = useMemo(
        () => [
            {
                header: 'Name',
                id: 'name',
                accessorFn: ({ name }) => name || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Country',
                id: 'country',
                accessorFn: ({ country }) => country || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Phone',
                id: 'phone',
                accessorFn: ({ phone }) => phone || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Location',
                id: 'location',
                accessorFn: ({ location }) => location || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            }
        ],
        []
    );

    const actionsMenu = useMemo(
        () =>
            ({ row }) => [
                <Button
                    variant="outlined"
                    color="error"
                    sx={{
                        p: 0,
                        m: 0,
                        borderColor: 'brown',
                        color: 'brown',
                        fontSize: '13px',
                        '&:hover': {
                            borderColor: 'brown',
                            color: 'white',
                            backgroundColor: 'brown'
                        }
                    }}
                    onClick={() => handleDelete(row?.original?.uuid)}
                >
                    Delete
                </Button>
            ],
        [handleDelete]
    );

    return (
        <Box>
            <Modal open={openModal} onClose={handleCloseModal} disableBackdropClick>
                <CreateBroker handleClose={handleCloseModal} />
            </Modal>
            <ReactTable
                renderToolbarInternalActions={({ table }) => (
                    <div onMouseDown={(e) => e.stopPropagation()}>
                        <MRT_ToggleGlobalFilterButton table={table} />
                        <IconButton
                            onClick={handleOpenModal}
                            title="Create Broker"
                        >
                            <AddBoxOutlinedIcon />
                        </IconButton>
                    </div>
                )}
                headerText={'Brokers'}
                columns={columns}
                data={brokers || []}
                actions={actionsMenu}
                isLoading={isGetBrokerLoading}
            />
        </Box>
    );
};

export default Brokers;
